import { useDispatch } from 'react-redux'

import { toggleDetectBanWordConfirmBox } from 'store/actions/confirmBox'
import { useGetBannedWordsQuery } from 'store/api'

export const useBanWord = () => {
  const bannedWords = useGetBannedWordsQuery({})?.data ?? []
  const dispatch = useDispatch()

  const isContainBanWord = (text: string, type = 'general') =>
    bannedWords.some(
      (w) => w.type === type && text.match(new RegExp(w.word, 'mu'))
    )

  const showDetectedBanWordAlert = () => {
    dispatch(toggleDetectBanWordConfirmBox())
  }

  const checkIsContainBadWordAndAlert = (text: string, onValid: () => void) => {
    if (!isContainBanWord(text)) {
      return onValid()
    }

    showDetectedBanWordAlert()
  }

  return {
    bannedWords,
    isContainBanWord,
    showDetectedBanWordAlert,
    checkIsContainBadWordAndAlert,
  }
}
